export const PORTFOLIO_CONTEXT = 'portfolio';
export const GOOGLE_ANALYTICS_TAG = 'PortfolioAnalysis';
